import { RouteRender } from "components";
import InvoiceDetail from "modules/invoices-siigo/detaill";
import InvoicesModule from "modules/invoices-siigo/invoices";
import VoucherTransactionReport from "modules/report/voucher-tranasction-report/voucher-transaction-report.module";
import VoucherTransactionDetails from "modules/report/voucher-tranasction-report/voucher-transaction-details.module";
import { Path } from "paths";
import React from "react";

export const SiigoInvoicesPage = () => {
  return (
    <RouteRender
      defaultRedirect={Path.SIIGO_INVOICES}
      renders={{
        [Path.SIIGO_INVOICES]: {
          exact: "true",
          component: InvoicesModule,
        },
        [Path.SIIGO_INVOICE_DETAIL]: {
          exact: "true",
          component: InvoiceDetail,
        },
        [Path.SIIGO_REFUND_VOUCHER_REPORT]: {
          exact: "true",
          component: VoucherTransactionReport,
        },
        [Path.SIIGO_VOUCHER_TOPUP_REPORT]: {
          exact: "true",
          component: VoucherTransactionReport,
        },
        [Path.SIIGO_ADJUSTMENT_VOUCHER_REPORT]: {
          exact: "true",
          component: VoucherTransactionReport,
        },
        [Path.SIIGO_VOUCHER_DETAILS]: {
          exact: "true",
          component: VoucherTransactionDetails,
        },
      }}
    />
  );
};
